import { Component, OnInit } from '@angular/core';
import { RegistrationStepService, RegistrationStepQuery, LoggingService, ErrorStateService, StepType, ProviderTranslation, TMAuthService } from '@fgb/core';

@Component({
  selector: 'fgb-registration-provider-oauth',
  templateUrl: './registration-provider-oauth.component.html',
  styleUrls: ['./registration-provider-oauth.component.scss']
})
export class RegistrationProviderOauthComponent implements OnInit {

  readonly stepType = StepType.ProviderOAuth
  customer: ProviderTranslation = { } as ProviderTranslation;
  hasAccountDetails : boolean = false;

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private logService: LoggingService,
    public errorService: ErrorStateService,
    public tmOauthService: TMAuthService,
  ) {}

  ngOnInit() {
    const step = this.registrationStepQuery.getStep(this.stepType);
    if (!step) {
      this.logService.warning('No step data found in the store for step', this.stepType);
      return;
    }

    if (step.Data != null && step.Data.ExternalRefNumber !== '') {
      this.customer.ExternalRefNumber = step.Data.ExternalRefNumber;
      this.customer.EmailAddress = step.Data.EmailAddress;
      this.hasAccountDetails = true;
    }
  }

  public LoginToOAuthProvider() {
    this.tmOauthService.login().then((callback : any) => {
      if (callback && callback.auth.AccountNumber) {
        this.customer.ExternalRefNumber=callback.auth.AccountNumber;
        this.customer.EmailAddress = callback.auth.username;
        this.hasAccountDetails = true;
      }
    }).catch(error => {
      this.errorService.addError("Authentication failed");
      this.logService.debug("Failed to authenticate", error);
      this.hasAccountDetails = false;
    })
  }

  public submitStep() {
    this.registrationStepService.submitRegistrationStepData(this.stepType, this.customer).toPromise();
  }

}
